enum submittedStep {
    submit = 1, //ยื่นเอกสาร, แก้ไขเอกสาร
    verifyDoc = 2, //ตรวจสอบเอกสาร
    specifyProjectType = 3, //กำหนดประเภทโครงการและกรรมการ
    specifyAdditionalDoc = 4, //กำหนดขอชุดโครงการที่ต้องส่ง
    specifySchedule = 5, //ชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
    commentary = 6, //บันทึกข้อคิดเห็นของกรรมการ
    synthesis = 7, //สังเคราะห์ข้อคิดเห็น
    synthesisReview = 8, //ออกผลการพิจารณา
    certification = 9, //ออกใบรับรอง
    sign = 10, //ลงนาม
    memoMessage = 11, //บันทึกข้อความ
    confirmProjectWithdraw = 12, //รับทราบการถอน
}
export default submittedStep
